import DictionaryIcon_Trans from "../../../assets/UI/DictionaryIcon_Trans.png";
import SearchBarDictionary from "../DictionaryComponents/SearchBar_Dictionary/SearchBar_Dictionary";
import "../Dictionary.css";
import HeaderNavNTM from "../../../Components/Header/Header_Nav_NoBottomMargin/Header_Nav_NBM";
import WordGridLarge from "../DictionaryComponents/WordGrid/WordGridLarge";

import { ChildrenSiblings } from "../../../SubjectData/BasicWords/Family";
import { ExtendedFamily } from "../../../SubjectData/BasicWords/Family";
import { MaritalFamily } from "../../../SubjectData/BasicWords/Family";
import { RespectfulTitles } from "../../../SubjectData/BasicWords/Family";

import Popup from "../../../Components/Popup/Dictionary_Popup";
import {useState} from "react";

export default function FamilyDictionary(){

    const [openPopup, setOpenPopup] = useState(null);

    const allData = [
        ...MaritalFamily, 
        ...ChildrenSiblings,
        ...ExtendedFamily,
        ...RespectfulTitles
    ];
    
        return(
       
               <div>
                   <HeaderNavNTM GoBack_to="/FamilyNav"/>
                   <div className="blue-header-dict">
                       
                       <img className="DictionaryImage" src={DictionaryIcon_Trans} alt="Dictionary"></img>
                      
                         <SearchBarDictionary data={allData} onSelectItem={setOpenPopup} />
                       
                   </div>
       
                   <div>
                       <WordGridLarge data={MaritalFamily} title="Marital Family" onSelectItem={setOpenPopup} />                        
                       <WordGridLarge data={ChildrenSiblings} title="Children & Siblings" onSelectItem={setOpenPopup} />
                       <WordGridLarge data={ExtendedFamily} title="Extended Family" onSelectItem={setOpenPopup} />    
                       <WordGridLarge data={RespectfulTitles} title="Respectful Titles" onSelectItem={setOpenPopup} />      
                                   
                       <Popup item={openPopup} onClose={() => setOpenPopup(null)} />
                  
                   </div>
                   
               </div>
       
           );
       
       }
       
    
    
    //Resources
        //Making a search bar
            //https://builtin.com/articles/react-search-bar